export const ANALYTICS_FEATURES = ['my-schedule', 'stats', 'stats/settings'];
